import {ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {View} from 'Common/artists/View';

export class ArtistsConfig 
{
	view() { return (new View()).view(); }

	routes() { return (new ArtistRoutes()).routes(); }
}
